import type { ReactNode } from 'react'
import cx from 'classnames'
import styles from './DocumentList.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgUploadDocsUrl from '@/assets/misc/img_upload-docs.svg'
import DragAndUploadIllustration from '@/components/SpotIllustration/DragAndUploadIllustration'

export interface DocumentListProps {
  /**
   * The loaded items, or their loading or error state.
   */
  children?: ReactNode
}

export function DocumentList({ children }: DocumentListProps) {
  return <div className={styles.root}>{children}</div>
}

export interface DocumentListItemsProps {
  isEmpty: boolean
  canUploadDocs: boolean
  compact?: boolean
  children?: ReactNode
  corporateMode: boolean
}

export function DocumentListItems({
  isEmpty,
  canUploadDocs,
  compact,
  children,
  corporateMode,
}: DocumentListItemsProps) {
  return (
    <div className={styles.documentsList}>
      {!isEmpty ? (
        children
      ) : (
        <div
          className={cx(
            styles.emptyStateContainer,
            !compact && styles.emptyPadding,
          )}
        >
          <EmptyState size="sm">
            {!corporateMode && (
              <EmptyStateIllustration
                src={imgUploadDocsUrl}
                illustration={byDesign(undefined, DragAndUploadIllustration)}
              />
            )}
            <EmptyStateTitle>
              {canUploadDocs ? 'Upload your first document' : 'No documents'}
            </EmptyStateTitle>
            <EmptyStateDescription>
              {canUploadDocs
                ? 'There are no documents in this workspace. Lets go create some!'
                : 'No documents have been uploaded to this job'}
            </EmptyStateDescription>
          </EmptyState>
        </div>
      )}
    </div>
  )
}
